
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 64 64"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"transform":"translate(32 32)"}},[_c('circle',{attrs:{"r":"5","cx":"24"}},[_c('animate',{attrs:{"attributeName":"fill-opacity","dur":"750ms","values":"1;.9;.85;.7;.4;.3;.3;.3;1","repeatCount":"indefinite"}})]),_c('circle',{attrs:{"r":"5","cx":"16.971","cy":"16.971"}},[_c('animate',{attrs:{"attributeName":"fill-opacity","dur":"750ms","values":".3;1;.9;.85;.7;.4;.3;.3;.3","repeatCount":"indefinite"}})]),_c('circle',{attrs:{"r":"5","cy":"24"}},[_c('animate',{attrs:{"attributeName":"fill-opacity","dur":"750ms","values":".3;.3;1;.9;.85;.7;.4;.3;.3","repeatCount":"indefinite"}})]),_c('circle',{attrs:{"r":"5","cx":"-16.971","cy":"16.971"}},[_c('animate',{attrs:{"attributeName":"fill-opacity","dur":"750ms","values":".3;.3;.3;1;.9;.85;.7;.4;.3","repeatCount":"indefinite"}})]),_c('circle',{attrs:{"r":"5","cx":"-24"}},[_c('animate',{attrs:{"attributeName":"fill-opacity","dur":"750ms","values":".4;.3;.3;.3;1;.9;.85;.7;.4","repeatCount":"indefinite"}})]),_c('circle',{attrs:{"r":"5","cx":"-16.971","cy":"-16.971"}},[_c('animate',{attrs:{"attributeName":"fill-opacity","dur":"750ms","values":".7;.4;.3;.3;.3;1;.9;.85;.7","repeatCount":"indefinite"}})]),_c('circle',{attrs:{"r":"5","cy":"-24"}},[_c('animate',{attrs:{"attributeName":"fill-opacity","dur":"750ms","values":".85;.7;.4;.3;.3;.3;1;.9;.85","repeatCount":"indefinite"}})]),_c('circle',{attrs:{"r":"5","cx":"16.971","cy":"-16.971"}},[_c('animate',{attrs:{"attributeName":"fill-opacity","dur":"750ms","values":".9;.85;.7;.4;.3;.3;.3;1;.9","repeatCount":"indefinite"}})])])])
          )
        }
      }
    